@if(type === 'select') {
  <select
    class="form-control"
    [class.is-invalid]="field.errors().length > 0"
    (blur)="field.setTouched()"
    (change)="onInput($any($event.target).value)"
    [value]="$any(field.value())"
    [attr.autocomplete]="autocomplete"
    [disabled]="disabled"
  >
    <ng-content></ng-content>
  </select>
}
@else if(type === 'radio') {
  <div [class.is-invalid]="field.errors().length > 0" class="d-flex justify-content-between">
    @for(option of options; track option.value) {
      <div class="form-check form-check-inline">
        <input 
          class="form-check-input" 
          type="radio" 
          [name]="name" 
          [id]="name + '_' + $index"
          [value]="option.value"
          [checked]="field.value() === option.value"
          (change)="onInput(option.value)"
          [disabled]="disabled"
        >
        <label class="form-check-label" [for]="name + '_' + $index">
          {{ option.label }}
        </label>
      </div>
    }
  </div>
}@else if(formatted) {
  <input
    [type]="type"
    class="form-control"
    [placeholder]="placeholder"
    [class.is-invalid]="field.errors().length > 0"
    (blur)="field.setTouched()"
    (input)="onInput($any($event.target).value)"
    [value]="field.displayValue()"
    [attr.autocomplete]="autocomplete"
    [disabled]="disabled"
  />
  <input
    type="hidden"
    class="form-control"
    [value]="$any(field.value())"
    [attr.autocomplete]="autocomplete"
  />
}@else if(type === 'textarea') {
  <textarea
    class="form-control rounded-0"
    [placeholder]="placeholder"
    [class.is-invalid]="field.errors().length > 0"
    (blur)="field.setTouched()"
    (input)="onInput($any($event.target).value)"
    [value]="$any(field.value())"
    [attr.autocomplete]="autocomplete"
    rows="6"
    [disabled]="disabled"></textarea>
}
@else {
<input
  [type]="type"
  class="form-control"
  [placeholder]="placeholder"
  [class.is-invalid]="field.errors().length > 0"
  (blur)="field.setTouched()"
  (input)="onInput($any($event.target).value)"
  [value]="$any(field.value())"
  [attr.autocomplete]="autocomplete"
  [attr.maxlength]="maxLength"
  [disabled]="disabled"
/>
}